import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormSelect } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { usePatientLetters } from "@/hooks/patient-content";
import { useDeleteOutboundFile, useUploadLetterAttachment, useUploadOutboundFile } from "@/hooks/outbound";
import { formatMonthDayYear } from "@/utils/format";
import { FileDropZone } from "./file-drop-zone";
import { FileCard } from "./file-card";
import { LetterPreviewModal } from "./letter-preview-modal";
/** Combined field: pick a letter (with preview) or upload a file, shown as one card. */
export function CombinedFileField(_ref) {
  var _field$max_size_mb, _field$accept$join, _field$accept, _letters$data;
  var field = _ref.field,
    fieldKey = _ref.fieldKey,
    value = _ref.value,
    valueName = _ref.valueName,
    setField = _ref.setField,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    selectedLetter = _useState[0],
    setSelectedLetter = _useState[1];
  var _useState2 = useState(null),
    previewLetterId = _useState2[0],
    setPreviewLetterId = _useState2[1];
  var _useState3 = useState(""),
    previewTitle = _useState3[0],
    setPreviewTitle = _useState3[1];
  var _useState4 = useState(null),
    attachedName = _useState4[0],
    setAttachedName = _useState4[1];
  var _useState5 = useState(null),
    attachedType = _useState5[0],
    setAttachedType = _useState5[1];
  var _useState6 = useState(null),
    error = _useState6[0],
    setError = _useState6[1];
  var letters = usePatientLetters(patientId, true);
  var attach = useUploadLetterAttachment(workspaceId, patientId);
  var upload = useUploadOutboundFile(workspaceId, patientId);
  var remove = useDeleteOutboundFile(workspaceId);
  var maxMb = (_field$max_size_mb = field.max_size_mb) !== null && _field$max_size_mb !== void 0 ? _field$max_size_mb : 50;
  var accept = (_field$accept$join = (_field$accept = field.accept) === null || _field$accept === void 0 ? void 0 : _field$accept.join(",")) !== null && _field$accept$join !== void 0 ? _field$accept$join : "";
  var options = ((_letters$data = letters.data) !== null && _letters$data !== void 0 ? _letters$data : []).map(function (letter) {
    return {
      value: String(letter.id),
      label: "".concat(letter.title, " \xB7 ").concat(formatMonthDayYear(letter.created_at))
    };
  });
  var removeExisting = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!value) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return remove.mutateAsync(value)["catch"](function () {
              return undefined;
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function removeExisting() {
      return _ref2.apply(this, arguments);
    };
  }();
  var storeFile = function storeFile(s3Key, contentType, name, type) {
    setField(fieldKey, s3Key);
    setField("".concat(fieldKey, "__ct"), contentType);
    setField("".concat(fieldKey, "__name"), name);
    setAttachedName(name);
    setAttachedType(type);
  };
  var onSelectLetter = function onSelectLetter(letterId) {
    var _letters$data2, _letter$title;
    trackEvent(ANALYTICS_EVENTS.LETTER, {
      fieldKey: fieldKey
    });
    setError(null);
    setSelectedLetter(letterId);
    if (!letterId) return;
    var letter = (_letters$data2 = letters.data) === null || _letters$data2 === void 0 ? void 0 : _letters$data2.find(function (item) {
      return String(item.id) === letterId;
    });
    setPreviewTitle((_letter$title = letter === null || letter === void 0 ? void 0 : letter.title) !== null && _letter$title !== void 0 ? _letter$title : t("letter", {
      defaultValue: "Letter"
    }));
    setPreviewLetterId(Number(letterId));
  };
  var onConfirmAttach = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var result, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(previewLetterId == null)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            _context2.p = 1;
            _context2.n = 2;
            return removeExisting();
          case 2:
            _context2.n = 3;
            return attach.mutateAsync(previewLetterId);
          case 3:
            result = _context2.v;
            storeFile(result.s3_key, "application/pdf", previewTitle, "letter");
            setPreviewLetterId(null);
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            setError(t("letter_attach_failed", {
              defaultValue: "Couldn't attach the letter."
            }));
            setPreviewLetterId(null);
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function onConfirmAttach() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onUpload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(file) {
      var result, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.FILE, {
              fieldKey: fieldKey
            });
            setError(null);
            if (!(file.size > maxMb * 1024 * 1024)) {
              _context3.n = 1;
              break;
            }
            setError(t("file_too_large", {
              defaultValue: "File exceeds ".concat(maxMb, " MB.")
            }));
            return _context3.a(2);
          case 1:
            _context3.p = 1;
            _context3.n = 2;
            return removeExisting();
          case 2:
            _context3.n = 3;
            return upload.mutateAsync(file);
          case 3:
            result = _context3.v;
            storeFile(result.s3_key, file.type, file.name, "file");
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            setError(t("file_upload_failed", {
              defaultValue: "Upload failed. Please try again."
            }));
          case 5:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 4]]);
    }));
    return function onUpload(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var onDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.FILE_REMOVE, {
              fieldKey: fieldKey
            });
            _context4.n = 1;
            return removeExisting();
          case 1:
            setField(fieldKey, "");
            setField("".concat(fieldKey, "__ct"), "");
            setField("".concat(fieldKey, "__name"), "");
            setAttachedName(null);
            setAttachedType(null);
            setSelectedLetter(null);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function onDelete() {
      return _ref5.apply(this, arguments);
    };
  }();
  var onCancelPreview = function onCancelPreview() {
    setPreviewLetterId(null);
    if (!value) setSelectedLetter(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-base-secondary"
  }, field.label, field.required ? /*#__PURE__*/React.createElement("span", {
    className: "text-sds-urgent-secondary"
  }, " *") : null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 rounded-sds-200 border border-sds-base-default p-3"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    placeholder: letters.isLoading ? t("loading", {
      defaultValue: "Loading…"
    }) : t("select_a_generated_letter", {
      defaultValue: "Select a generated letter from navigation"
    }),
    data: options,
    value: selectedLetter,
    onChange: onSelectLetter,
    disabled: letters.isLoading || attach.isLoading,
    searchable: true,
    clearable: true,
    withinPortal: true,
    nothingFound: t("no_letters", {
      defaultValue: "No letters"
    }),
    "data-testid": "letter-".concat(fieldKey)
  }), value ? /*#__PURE__*/React.createElement(FileCard, {
    fileName: attachedName || valueName,
    s3Key: value,
    sourceLabel: attachedType === "letter" ? t("from_timeline_letter", {
      defaultValue: "From timeline letter"
    }) : attachedType === "file" ? t("uploaded", {
      defaultValue: "Uploaded"
    }) : t("attached", {
      defaultValue: "Attached"
    }),
    onDelete: onDelete,
    isDeleting: remove.isLoading,
    testId: "file-remove-".concat(fieldKey)
  }) : /*#__PURE__*/React.createElement(FileDropZone, {
    accept: accept,
    maxMb: maxMb,
    isUploading: upload.isLoading,
    onFile: onUpload,
    testId: "file-".concat(fieldKey)
  })), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-label-base text-sds-urgent-secondary"
  }, error) : null, /*#__PURE__*/React.createElement(LetterPreviewModal, {
    opened: previewLetterId != null,
    letterId: previewLetterId,
    letterTitle: previewTitle,
    patientId: patientId,
    workspaceId: workspaceId,
    isAttaching: attach.isLoading,
    onClose: onCancelPreview,
    onAttach: onConfirmAttach
  }));
}